import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["moon", "sun"]
    static values = {
        defaultTheme: { type: String, default: "dark" }
    }

    connect() {
        this.loadTheme()
    }

    change() {
        this.isDarkThemeEnabled() ? this.setLightTheme() : this.setDarkTheme()
        this.updateToggles()
    }

    loadTheme() {
        const theme = localStorage.getItem("theme") || this.defaultThemeValue
        theme === "dark" ? this.setDarkTheme() : this.setLightTheme()
        localStorage.setItem("theme", theme)
        this.updateToggles()
    }

    setDarkTheme() {
        this.setTheme("dark")
    }

    setLightTheme() {
        this.setTheme("light")
    }

    setTheme(mode) {
        document.body.setAttribute("data-mode", mode)
        localStorage.setItem("theme", mode)
    }

    updateToggles() {
        const isDark = this.isDarkThemeEnabled();
        this.sunTarget.classList.toggle("hidden", isDark)
        this.moonTarget.classList.toggle("hidden", !isDark)
    }

    isDarkThemeEnabled() {
        return document.body.getAttribute("data-mode") === "dark"
    }
}
